<template>
    <h1>{{ projectPath }}</h1>
    <div>
        <myCloudy :projectPath=projectPath :projectDetail="'rentalinformation/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'exteriorview/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'header/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'siteplan/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'siteplan/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'floor_plan/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'floor_plan/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'general/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'general/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'booking/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'mockup/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'showroom/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'allocation/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'allocation/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'facilities/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'pricelist/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'pricelist/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'panel_backers/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'private/pdf'" />
        <myCloudy :projectPath=projectPath :projectDetail="'introduction/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'amenities/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'developer/img'" />
        <myCloudy :projectPath=projectPath :projectDetail="'location/img'" />
 
        <myCldRaw :projectPath=projectPath :projectDetail="'general/video'" />
        <myCldRaw :projectPath=projectPath :projectDetail="'showroom/video'" />

      
    </div>
</template>

<script>
//http://localhost:8080/?p=jsnvic/nexus
import myCloudy from './myCloudy.vue'; // Import the JSON file
import myCldRaw from './myCldRaw.vue'; // Import the JSON file
export default {
    name: 'g_json',
    props: {
        urlParam: {
            type: String,
            required: true,
        }
    },

    computed:
    {
        projectPath() {
            return this.urlParam.slice(3);
        }

    },
    components: {
        myCloudy,
        myCldRaw
    }
};
</script>

<style scoped>
/* Add any styles for your component here */
</style>